module.exports = __webpack_public_path__ + "img/work.ef9a8351.svg";